// extracted by mini-css-extract-plugin
module.exports = {"bulletList":"SharedDetails_bulletList__8cPkA","anchor":"SharedDetails_anchor__IHEST"};